import { useKeycloak } from "@react-keycloak/web";
import { Navigate  } from "react-router-dom";

const PublicRoute = ({ children }) => {
    const { keycloak } = useKeycloak();

    return !keycloak.authenticated ? children : <Navigate to="/dashboard" replace={true} />
};

export default PublicRoute;
